import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import { CorreosMasivosLayout } from "./CorreosMasivosLayout";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/comunicaciones",
    label: "Comunicaciones",
  },
  {
    path: "/correos_masivos",
    label: "Correos masivos",
    isActive: true,
  },
];

function CorreosMasivos() {
  return (
    <Page
      title="Correos Masivos"
      description="Envío de correos en masa a listas de clientes."
      breadCrumbs={breadCrumbs}
    >
      <CorreosMasivosLayout />
    </Page>
  );
}

export default CorreosMasivos;
